import theme from '../../../theme';

export const tooltipStyles = {
  borderRadius: '8px',
  border: `1px solid ${theme.admanColors!.gray.light.bg3[2]}`,
  boxShadow: '0px 0px 32px -8px rgba(23, 29, 35, 0.25)',
  padding: 0,
  margin: 0,
  zIndex: 100,
};

export const globalCloseEvents = { clickOutsideAnchor: true, escape: true, scroll: true, resize: true };
